//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Nutrient from './list';
import NutrientEdit from './edit';

export const FilterNutrient = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[2] !== "nutrient") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterNutrient.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/nutrient" exact component={Nutrient} isPrivate/>
      <Route path="/premixlabel/nutrient/edit/:id" exact component={NutrientEdit} isPrivate/>
    </FilterNutrient.Provider>
  )
}